import { isNil, isNaN } from 'lodash';
const { GLOBAL_INFO } = window;
export const enableMultiOrgAuth = () => !!GLOBAL_INFO.deploySettingFlag?.enableMultiOrgAuth;
const defaultMaxExpireDay = 365;
export const getDefaultMaxExpireDay = () => {
    const maxExpire = GLOBAL_INFO.deploySettingFlag?.roleUserDefaultMaxExpire;
    const day = +maxExpire;
    if (isNil(maxExpire) || isNaN(day))
        return defaultMaxExpireDay;
    return day >= 0 ? day : defaultMaxExpireDay;
};
